import { render, staticRenderFns } from "./IPNodeProperties.vue?vue&type=template&id=e2067ac8&scoped=true"
import script from "./IPNodeProperties.vue?vue&type=script&lang=js"
export * from "./IPNodeProperties.vue?vue&type=script&lang=js"
import style0 from "./IPNodeProperties.vue?vue&type=style&index=0&id=e2067ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2067ac8",
  null
  
)

export default component.exports